import { html, LitElement } from "lit";
import { customElement, query, state } from "lit/decorators.js";
import { shared } from "../../styles";
import type { SignatureDialogResult } from "./signature-dialog";

@customElement("ptc-contact-info-form")
export class ContactInfoForm extends LitElement {
    static styles = [shared];

    @state()
    private _address: string | null = null;

    @state()
    private _firstName: string | null = null;

    @state()
    private _lastName: string | null = null;

    @state()
    private _email: string | null = null;

    @state()
    private _phone: string | null = null;

    public get info(): SignatureDialogResult["info"] | null {
        if (!this._formElement?.reportValidity()) {
            return null;
        }

        return {
            firstName: this._firstName!,
            lastName: this._lastName!,
            address: this._address!,
            email: this._email!,
            phone: this._phone!,
        };
    }

    @query("form")
    private _formElement?: HTMLFormElement;

    render() {
        const layoutClasses = "padded horizontal evenly stretching layout";

        return html`<form class="padded vertical layout">
            <h2>Kontaktdaten</h2>
            <div class="${layoutClasses}">
                <label for="firstName">Vorname</label>
                <input
                    id="firstName"
                    type="text"
                    .required=${true}
                    .value=${this._firstName || ""}
                    @input=${(e: InputEvent) => (this._firstName = (e.target as HTMLInputElement).value)}
                />
            </div>
            <div class="${layoutClasses}">
                <label for="lastName">Nachname</label>
                <input
                    id="lastName"
                    type="text"
                    .required=${true}
                    .value=${this._lastName || ""}
                    @input=${(e: InputEvent) => (this._lastName = (e.target as HTMLInputElement).value)}
                />
            </div>
            <div class="${layoutClasses}">
                <label for="address">Adresse</label>
                <input
                    id="address"
                    type="text"
                    .required=${true}
                    .value=${this._address || ""}
                    @input=${(e: InputEvent) => (this._address = (e.target as HTMLInputElement).value)}
                />
            </div>
            <div class="${layoutClasses}">
                <label for="email">Email</label>
                <input
                    id="email"
                    type="email"
                    .required=${true}
                    .value=${this._email || ""}
                    @input=${(e: InputEvent) => (this._email = (e.target as HTMLInputElement).value)}
                />
            </div>
            <div class="${layoutClasses}">
                <label for="phone">Telefon</label>
                <input
                    id="phone"
                    type="tel"
                    .required=${true}
                    .value=${this._phone || ""}
                    @input=${(e: InputEvent) => (this._phone = (e.target as HTMLInputElement).value)}
                />
            </div>
        </form>`;
    }
}
